import React from "react";
import {
  GridColumn,
  Header,
  Segment,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "semantic-ui-react";
import moment from "moment";
import { SWBLabel } from "../UtilComponents";

const UserSwapInteractionTable = ({ user_interactions }) => {
  return (
    <GridColumn>
      <Segment>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Header style={{ color: "#444" }}>
            {user_interactions.length} User Interactions
          </Header>
        </div>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell className="left-header">
                Interaction ID
              </Table.HeaderCell>

              <Table.HeaderCell className="inner-header">
                Action
              </Table.HeaderCell>
              <Table.HeaderCell className="inner-header">
                Module
              </Table.HeaderCell>

              <Table.HeaderCell className="inner-header">Slot</Table.HeaderCell>

              <Table.HeaderCell className="right-header">
                Created At
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <TableBody>
            {user_interactions.map(
              ({
                module_number,
                created_at,
                action,
                slot_number,
                interaction_id,
              }) => (
                <TableRow>
                  <TableCell>{interaction_id}</TableCell>
                  <TableCell>{action}</TableCell>

                  <TableCell>{module_number}</TableCell>

                  <TableCell>{slot_number}</TableCell>

                  <TableCell>
                    {moment(created_at).format("DD-MM-YYYY HH:mm:ss")}
                  </TableCell>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
        {!user_interactions.length && (
          <div style={{ textAlign: "center", color: "#444", width: "100%" }}>
            no data available
          </div>
        )}
      </Segment>
    </GridColumn>
  );
};

export default UserSwapInteractionTable;
